import Vue from "vue";
import Router from "vue-router";
import store from "./store";

// const Foo = { template: "<div>JENN</div>" };
// const Foo = {
//   template: "<div>User {{ $route.params }}</div>"
// };

Vue.use(Router);

const router = new Router({
  mode: process.env.CORDOVA_PLATFORM ? "hash" : "hash",
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "splash",
      meta: {
        bodyClass: "bg-image"
      },
      component: () => import("./views/Splash.vue")
    },
    {
      path: "/choose-branch",
      name: "choose-branch",
      meta: {
        bodyClass: "bg-image",
        guest: true
      },
      component: () => import("./views/ChooseBranch.vue")
    },
    {
      path: "/about",
      name: "about",
      component: function() {
        return import("./views/About.vue");
      }
    },
    {
      path: "/contact",
      name: "contact",
      component: function() {
        return import("./views/Contact.vue");
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: function() {
        return import("./views/Privacy.vue");
      }
    },
    {
      path: "/terms",
      name: "terms",
      component: function() {
        return import("./views/Terms.vue");
      }
    },
    {
      path: "/applicant/terms",
      name: "applicant-terms",
      component: function() {
        return import("./views/Applicant/Terms.vue");
      }
    },
    {
      path: "/company/terms",
      name: "company-terms",
      component: function() {
        return import("./views/Company/Terms.vue");
      }
    },
    {
      path: "/tutorial",
      name: "tutorial",
      meta: {
        bodyClass: "bg-image"
      },
      component: () => import("./views/Tutorial.vue"),
      props: true
    },
    {
      path: "/login",
      name: "login",
      meta: {
        bodyClass: "bg-image login-page",
        guest: true
      },
      component: () => import("./views/Login.vue")
    },
    {
      path: "/loginWithToken/:token/:redirectTo",
      name: "login-with-token",
      meta: {
        bodyClass: "bg-image login-page",
        guest: true
      },
      component: () => import("./views/LoginWithToken.vue"),
      props: true
    },
    {
      path: "/forgot",
      name: "forgot-password",
      meta: {
        bodyClass: "bg-image",
        guest: true
      },
      component: () => import("./views/Forgot-password.vue")
    },
    {
      path: "/reset",
      name: "reset",
      meta: {
        guest: true
      },
      component: () => import("./views/Reset.vue")
    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: () => import("./views/Reset-password.vue")
    },
    {
      path: "/update-password",
      name: "update-password",
      component: () => import("./views/Update-password.vue")
    },
    {
      path: "/register-applicant",
      name: "register-1",
      meta: {
        guest: true
      },
      component: () => import("./views/Register.vue"),
      props: { type: 1 }
    },
    {
      path: "/register-company",
      name: "register-2",
      meta: {
        guest: true
      },
      component: () => import("./views/Register.vue"),
      props: { type: 2 }
    },
    {
      path: "/register*",
      redirect: { name: "choose-branch" }
    },
    {
      path: "/choice",
      redirect: { name: "choose-branch" }
    },

    {
      path: "/verify",
      name: "verify",
      meta: {
        guest: true
      },
      component: () => import("./views/Verify.vue")
    },
    {
      path: "/job/step-1",
      name: "job_step-1",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Job/Step-1.vue")
    },
    {
      path:"/job/step-1-healthcare",
      name: "job_step-1-healthcare",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Job/Step-1-healthcare.vue")
    },
    {
      path: "/job/step-2",
      name: "job_step-2",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Job/Step-2.vue")
    },
    {
      path: "/job/step-2-healthcare",
      name: "job_step-2-healthcare",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Job/Step-2-healthcare.vue")
    },
    {
      path: "/job/step-3",
      name: "job_step-3",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Job/Step-3.vue")
    },
    {
      path: "/company/jobs",
      name: "company-jobs",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/Jobs.vue")
    },
    {
      path: "/job/:id",
      name: "job-view",
      meta: {
        requiresAuth: true
      },
      component: () => import("./views/Job/View.vue"),
      props: true
    },
    {
      path: "/job-healthcare/:id",
      name: "job-healthcare-view",
      meta: {
        requiresAuth: true
      },
      component: () => import("./views/Job/ViewHealthcare.vue"),
      props: true
    },
    {
      path: "/job/:id/applicants",
      name: "job-applicants",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/JobApplicants.vue"),
      props: true
    },
    {
      path: "/job/:id/matches",
      name: "job-matches",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Job/Matches.vue"),
      props: true
    },
    {
      path: "/job/:id/:action",
      name: "job",
      meta: {
        requiresAuth: true
      },
      component: () => import("./views/Job/View.vue"),
      props: true
    },
    {
      path: "/job-healthcare/:id/:action",
      name: "job-healthcare",
      meta: {
        requiresAuth: true
      },
      component: () => import("./views/Job/ViewHealthcare.vue"),
      props: true
    },
    {
      path: "/job/application/:id",
      name: "job-application",
      meta: {
        requiresAuth: true
      },
      component: () => import("./views/Job/View.vue"),
      props: true
    },
    {
      path: "/company/details/:action", // registration part 2
      name: "company-details",
      component: () => import("./views/Company/Details.vue"),
      props: true
    },
    {
      path: "/company/location/add",
      name: "location-add",
      component: () => import("./views/Company/AddLocation.vue")
    },
    {
      path: "/company/location/edit/:id",
      name: "edit-address",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/AddLocation.vue"),
      props: true
    },
    {
      path: "/company/dashboard",
      name: "company-dashboard",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/Dashboard.vue"),
      props: true
    },
    {
      path: "/company/edit",
      name: "company-edit",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/Edit.vue")
    },
    {
      path: "/company/profile",
      name: "company-profile",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/Profile.vue")
    },
    {
      path: "/company/profile/step-1",
      name: "company-step_1",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/Step-1.vue")
    },
    {
      path: "/company/applicants",
      name: "company-applicants",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/Applicants.vue")
    },
    {
      path: "/company/matches",
      name: "company-matches",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/Matches.vue")
    },
    {
      path: "/company/healthcare-matches",
      name: "company-healthcare-matches",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/HealthcareMatches.vue")
    },
    {
      path: "/applicant/dashboard",
      name: "applicant-dashboard",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Dashboard.vue")
    },
    {
      path: "/applicant/matching",
      name: "applicant-match-settings",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Match.vue")
    },
    {
      path: "/applicant/details/:action", // registration part 2
      name: "applicant-details",
      component: () => import("./views/Applicant/Details.vue"),
      props: true
    },
    {
      path: "/applicant/jobs",
      name: "applicant-jobs",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Jobs.vue")
    },
    {
      path: "/applicant/profile",
      name: "applicant-profile",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Profile.vue")
    },
    {
      path: "/applicant/view/:id",
      name: "view-applicant",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/CandidateProfile.vue"),
      props: true
    },
    {
      path: "/healthcare-applicant/view/:id",
      name: "view-healthcare-applicant",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/HealthcareCandidateProfile.vue"),
      props: true
    },
    {
      path: "/matched/:id",
      name: "view-match",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/CandidateProfile.vue"),
      props: true
    },
    {
      path: "/healthcare-matched/:id",
      name: "view-healthcare-match",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/HealthcareCandidateProfile.vue"),
      props: true
    },
    {
      path: "/applicant/profile/step-1/:action",
      name: "applicant-step_1",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Step-1.vue"),
      props: true
    },
    {
      path: "/applicant/step-2/:action",
      name: "quick-step_2",
      component: () => import("./views/Applicant/Quick-Step-2.vue"),
      props: true
    },
    {
      path: "/applicant/profile/step-2/:action",
      name: "applicant-step_2",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Step-2.vue"),
      props: true
    },
    {
      path: "/applicant/profile/step-5/:action",
      name: "applicant-step-5",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Step-5.vue"),
      props: true
    },
    {
      path: "/applicant/profile/step-4/:action",
      name: "applicant-step_4",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/old-Step-3.vue"),
      props: true
    },
    {
      path: "/applicant/step-3/:action",
      name: "quick-step_3",
      component: () => import("./views/Applicant/Quick-Step-3.vue"),
      props: true
    },
    {
      path: "/applicant/profile/step-3/:action",
      name: "applicant-step_3",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Step-3.vue"),
      // props: true,
      props: true
    },
    {
      path: "/applicant/profile/experience-childcare/:action",
      name: "experience-childcare",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Experience-Childcare.vue"),
      // props: true,
      props: true
    },
    {
      path: "/applicant/salary-details",
      name: "salary-details",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Salary.vue")
    },
    {
      path: "/applicant/location",
      name: "location",
      component: () => import("./views/Applicant/Location.vue")
    },
    {
      path: "/applicant/availability",
      name: "availability",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Availability.vue")
    },
    {
      path: "/applicant/work/add",
      name: "work-add",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/AddWork.vue")
    },
    {
      path: "/applicant/work/edit/:id",
      name: "edit-work",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/AddWork.vue"),
      props: true
    },
    {
      path: "/applicant/education/add",
      name: "education-add",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/AddEducation.vue")
    },
    {
      path: "/applicant/applicant-zzp-documents",
      name: "zzpdocs",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/ZzpDocuments.vue")
    },
    {
      path: "/applicant/diplomas",
      name: "applicant-diplomas",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Diploma.vue")
    },
    {
      path: "/applicant/education/edit/:id",
      name: "edit-education",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/AddEducation.vue"),
      props: true
    },
    {
      path: "/applicant/edit",
      name: "applicant-edit",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Edit.vue")
    },
    {
      path: "/recommended/jobs",
      name: "recommended-jobs",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Job/Match.vue")
    },
    {
      path: "/jobs/match",
      name: "jobs-match",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Job/Match.vue")
    },
    {
      path: "/jobs/recommended",
      name: "jobs-recommended",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Job/Recommended.vue")
    },
    {
      path: "/jobs/pending",
      name: "jobs-pending",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Job/Pending.vue")
    },
    {
      path: "/jobs/approved",
      name: "jobs-approved",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Job/Approved.vue")
    },
    {
      path: "/jobs/history",
      name: "jobs-history",
      meta: {
        requiresAuth: true,
        is_applicant: true
      },
      component: () => import("./views/Applicant/Job/History.vue")
    },
    {
      path: "/jobs/open",
      name: "jobs-open",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/Job/Open.vue")
    },
    {
      path: "/jobs/closed",
      name: "jobs-closed",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/Job/Closed.vue")
    },
    {
      path: "/jobs/archived",
      name: "jobs-archived",
      meta: {
        requiresAuth: true,
        is_company: true
      },
      component: () => import("./views/Company/Job/Archived.vue")
    },
    {
      path: "/delete",
      name: "delete",
      meta: {
        requiresAuth: true
      },
      component: () => import("./views/Delete.vue")
    },
    {
      path: "/notifications",
      name: "notifications",
      meta: {
        requiresAuth: true
      },
      component: () => import("./views/Notifications.vue")
    },
    {
      path: "/TutorialLeerkracht",
      name: "TutorialDocent",
      meta: {
        bodyClass: "bg-image",
        guest: true
      },
      component: () => import("./views/TutorialDocent.vue")
    },
    {
      path: "/TutorialSchool",
      name: "TutorialSchool",
      meta: {
        bodyClass: "bg-image",
        guest: true
      },
      component: () => import("./views/TutorialSchool.vue")
    },
    {
      path: "/applicant/step-1-healthcare",
      name: "applicant-step-1-healthcare",
      component: () => import("./views/Applicant/Step-1-healthcare-candidate.vue"),
      props: false
    },
  ]
});

const reset = [];
const x_excluded = [
  "splash",
  "tutorial",
  "applicant-edit",
  "company-edit",
  "salary-details",
  "location",
  "availability",
  "work-add",
  "education-add",
  "location-add",
  "edit-address"
  // "view-applicant",
  // "job"
];

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem("user-token") || !localStorage.getItem("branch")) {
      localStorage.clear();
      next({ name: "login" });
    } else {
      let user = JSON.parse(localStorage.getItem("user"));
      if (to.matched.some(record => record.meta.is_company)) {
        if (user.type == 2) {
          next();
        } else if (user.type == 1) {
          next({ name: "applicant-dashboard" });
        }
      } else if (to.matched.some(record => record.meta.is_applicant)) {
        if (user.type == 1) {
          next();
        } else if (user.type == 2) {
          next({ name: "company-dashboard" });
        }
      } else {
        next();
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    let user = JSON.parse(localStorage.getItem("user"));
    if (!localStorage.getItem("user-token")) {
      next();
    } else if (user.type) {
      if (to.name === "login-with-token" && to.params.redirectTo) {
        next({ name: to.params.redirectTo });
      } else if (user.type == 1) {
        next({ name: "applicant-dashboard" });
      } else if (user.type == 2) {
        next({ name: "company-dashboard" });
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

router.afterEach(to => {
  if (!x_excluded.includes(to.name)) {
    if (reset.includes(to.name)) {
      store.state.user_history = [];
    } else {
      var obj = { path: to.path };
      store.state.user_history.push(obj);
      store.state.user_history = removeRepeatHistory(to.path);
    }
  }

  store.state.notification.notifications = [];
  store.state.loading = false;
  window.scrollTo(0, 0);
});

function removeRepeatHistory(last) {
  let history = store.state.user_history;
  let newArray = [];
  jQuery.each(history, function(k, v) {
    var obj = { path: v.path };
    newArray.push(obj);
    if (v.path == last) {
      return false;
    }
  });
  return newArray;
}

export default router;
